import script from "./ContentWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./ContentWrapper.vue?vue&type=style&index=0&id=51f36bfe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f36bfe"]])

export default __exports__